import axios from "axios";

declare global {
  interface Window { fbq: any; clarity: any; _hsq: any; }
}

export type TrackingData = {
  value: number;
  plan: string;
  email: string;
  phone: string;
  name: string;
  utmSource: string;
  utmCampaign: string;
  utmMedium: string;
  utmContent: string;
  utmTerm: string;
  origin: string;
  // Optional: set by funnel.ts so the Conversions API can dedupe against the pixel hit.
  eventId?: string;
  currency?: string;
  transactionId?: string;
  status?: string;
};

export function getConversionLink() {
  if ((window.location.href).toString().indexOf('utm') > -1) {
    return (window.location.href).toString();
  } else if ((localStorage.getItem('conversionLink') || '').toString().indexOf('utm') > -1) {
    return (localStorage.getItem('conversionLink') || '').toString();
  }

  return window.location.href;
}

export function getFacebookFBP() {
  const cookies = (document.cookie).split(';');

  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i].trim();

    if (cookie.startsWith('_fbp=')) {
        return cookie.substring(5);
    }
  }

  return null;
}

export function getFacebookCookieFBC() {
  const cookies = (document.cookie).split(';');

  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i].trim();

    if (cookie.startsWith('_fbc=')) {
      return cookie.substring(5);
    }
  }

  return null;
}

export function getFacebookFBC() {
  const urlParams = new URLSearchParams(getConversionLink());

  if (urlParams.has('fbclid')) {
    return urlParams.get('fbclid');
  }

  return getFacebookCookieFBC();
}

function getHubspotEvent(eventType: string) {
  // if (eventType === 'Lead') {
  //   return 'pe44709355_register';
  // } else if (eventType === 'TrialView') {
  //   return 'pe44709355_trialview';
  // } else if (eventType === 'Purchase') {
  //   return 'pe44709355_lead';
  // } else if (eventType === 'PurchaseFail') {
  //   return 'pe44709355_purchasefail';
  // } else
  if (eventType === 'Login') {
    return 'pe44709355_login';
  }

  return eventType;
}

async function trackUser(
  eventType: string,
  event: string,
  data: any = {},
  options: {skipGtag?: boolean} = {},
) {
  const eventData = {
    ...data,
  };

  // try {
  //   if (!!window.fbq) {
  //     window.fbq(eventType, event, eventData);
  //   }
  // } catch (e) {
  //   console.log('Problem to track fb', e);
  // }

  try {
    if (options.skipGtag) {
      // funnel.ts already pushed this event to the dataLayer for GA4.
    } else if (!!window.gtag && (event).toString().toLowerCase() === 'purchase') {
      gtag('event', 'purchase', eventData);
    } else if (!!window.gtag) {
      gtag('event', event, eventData);
    }
  } catch (e) {
    console.log('Problem to track gtag', e);
  }

  try {
    if (!!window.clarity) {
      window.clarity('set', 'conversionType', event, eventData);

      if (eventData && eventData?.email) {
        window.clarity('set', 'userEmail', eventData?.email);
      }
    }
  } catch (e) {
    console.log('Problem to track clarity', e);
  }

  try {
    if (!!window._hsq && eventData?.email) {
      window._hsq.push(['identify', {email: eventData?.email}]);
    }
  } catch (e) {
    console.log('Problem to track hubspot', e);
  }

  try {
    if (!!window._hsq) {
      setTimeout(() => {
        window._hsq.push([
          'trackCustomBehavioralEvent',
          {
            name: getHubspotEvent(event),
            properties: {
              ...eventData,
            },
          },
        ]);
      }, 200);

      console.log({
        name: getHubspotEvent(event),
      });
    }
  } catch(e) {
    console.log('Problem to add custom event hubspot', e);
  }

  // try {
  //   if (eventData && eventData?.email) {
  //     window.amplitude.add(window.sessionReplay.plugin({sampleRate: 1}));

  //     window.amplitude.init('1c7e2e4695fe14252acd25cb1050674', eventData?.email, {
  //       autocapture: {
  //         attribution: true,
  //         pageViews: true,
  //         sessions: true,
  //         formInteractions: true,
  //         fileDownloads: true,
  //         elementInteractions: true,
  //       },
  //     });
  //   }

  //   window.amplitude.track(eventType, eventData);
  // } catch (e) {
  //   console.log('Error to track amplitude', e);
  // }
}

export async function trackingEventSmartplayer(eventName: string, data: TrackingData) {
  let ipInfo = null;

  try {
    ipInfo = await axios.get('https://ipinfo.io/json?token=16cc9471c83fb9');
  } catch {
    ipInfo = null;
  }

  try {
    const eventData = {
      'eventName': eventName,
      'value': data?.value || 0,
      'plan': data?.plan || '',
      'email': data?.email || '',
      'phone': data?.phone || '',
      'name': data?.name || '',
      'city': ipInfo?.data?.city || '',
      'state': ipInfo?.data?.region || '',
      'country': ipInfo?.data?.country || '',
      'zipCode': ipInfo?.data?.postal || '',
      'ip': ipInfo?.data?.ip || '',
      'fbp': getFacebookFBP() || '',
      'fbc': getFacebookFBC() || '',
      'resolution': `${window.screen.width}x${window.screen.height}` || '',
      'utmSource': data?.utmSource || '',
      'utmCampaign': data?.utmCampaign || '',
      'utmMedium': data?.utmMedium || '',
      'utmContent': data?.utmContent || '',
      'utmTerm': data?.utmTerm || '',
      'language': navigator.language || (navigator as any)?.userLanguage || '',
      'url': getConversionLink(),
      'referrer': document.referrer,
      'eventId': data?.eventId || '',
      'currency': data?.currency || 'BRL',
      'transactionId': data?.transactionId || '',
      'status': data?.status || '',
    };

    const token = btoa(JSON.stringify(eventData)).toString().split('').reverse().join('');

    await axios.post('https://tracking.scaleup.com.br/web-event', { token }, {
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      console.log('Response', response);
    }).catch((error) => {
      console.log('Error', error);
    });
  } catch (e) {
    return;
  }
}

export default trackUser;
